import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GoogleMapReact from 'google-map-react';
import FaqTabs from './FaqTabs';
import FormLabel from './FormLabel';
import Button from './Button';
import Input from './Input';
import TextArea from './TextArea';
import $ from 'jquery';
const AnyReactComponent = ({ text }) => <div>{text}</div>;

class Tab4 extends Component {
	constructor(props){
		super(props)
		this.state ={
			name:'',
			email:'',
			quest:''
		}
		this.handleChange = this.handleChange.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
	}
	handleChange = (e) => {
		let newState = {}
		newState[e.target.name] = e.target.value
		this.setState(newState)
	}
	handleSubmit = (e,message) => {
		e.preventDefault()
		let formDataFaq = {
			formSender : this.state.name,
			formEmail: this.state.email,
			formQuest: this.state.quest
		} 
		if(formDataFaq.formSender < 1 || formDataFaq.formEmail < 1 || formDataFaq.formQuest < 1){
			return false;
		}
		$.ajax({
			url: 'some',
			dataType: 'json',
			type: 'POST',
			data: formDataFaq,
			success: function (data) {
				console.log(data);
			} ,
			error: function(xhr, status, err) {
				console.error(status, err.toString())
				alert('There was some problem with sending your message.')
			 }
		})
		this.SetState({
			name: '',
			email: '',
			quest:''
		})
	}



	static defaultProps = {
		center: {
			lat: -7.918879,
			lng: 112.586691
		},
		zoom: 17
	};
	render() {
		return (
			<div id="faq">
				<div className="section">
					<div className="content faq-content">
						<div className="columns">
							<div className="column ">
								<div className="title is-4">
									<h4> Head Office</h4>
								</div>
								<p>
									Deliv Technologies Perumahan
									<br />
									Villa Sengkaling Blok T No. 4
									<br />
									Kota Malang, Jawa Timur.
								</p>
							</div>
							<div className="column ">
								<div style={{ height: '40vh', width: '100%' }}>
									<GoogleMapReact
										bootstrapURLKeys={{ key: 'AIzaSyDlqjIzmSweSlzOUOUHhrE2BIrTDa7hhdw' }}
										defaultCenter={this.props.center}
										defaultZoom={this.props.zoom}
									>
										<AnyReactComponent
											lat={59.955413}
											lng={30.337844}
											text={'Kreyser Avrora'}
										/>
									</GoogleMapReact>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="section">
					<div className="content faq-content">
						<div className="columns">
							<div className="column ">
								<div className="title is-4">
									<h4> Kirim Kami Surel!</h4>
								</div>
								<p>Bila ada pertanyaan lebih, silahkan kirimkan kami email</p>
							</div>
							<div className="column ">
							<form onSubmit={this.handleSubmit}>
								<div className="columns">
									<div className="column">								
										<div className="field">
											<FormLabel htmlFor='formName' title='Name: ' />
											<Input
												htmlFor='nameInput'
												required='true'
												type='text'
												name='name'
												styleName='fas fa-user'
												placeholder='Nama Anda'
												onChange={this.handleChange}
												value={this.state.name}
											/>
										</div>
									</div>
									<div className="column">
										<div className="field">
											<FormLabel htmlFor='formEmail' title='Email: ' />
											<Input 
												htmlFor='emailInput'
												required='true'
												type='email'
												name='email'
												styleName='fas fa-envelope'
												placeholder='Email Anda'
												onChange={this.handleChange}
												value={this.state.email}
												/>
										</div>
									</div>
								</div>
								<div className="field">
									<FormLabel htmlFor='FormQuest' title='Pertanyaan: ' />
									<TextArea 
									htmlFor='questInput'
									required='true'
									styleName='textarea'
									placeholder='Silahkan mengisi permasalahan atau pertanyaan'
									onChange={this.handleChange}
									value={this.state.quest}
									/>
								</div>
								<Button
									type='submit'
									value='submit'
									text='Kirim'
								/>
								</form>
							</div>						
						</div>
					</div>
				</div>
				<div className="section">
					<div className="content faq-content">
						<div className="columns">
							<div className="column ">
								<div className="title is-4">
									<h4> Butuh Respon cepat?</h4>
								</div>
								<p>
									Dapatkan tanggapan cepat melalui Twitter. Tweet pertanyaan Anda dan sebutkan
									@delivid untuk segera dilayani oleh layanan pelanggan kami.
								</p>
							</div>
							<div className="column is-flex is-vcentered is-horizontal-center">
								<a
									href="https://twitter.com/intent/tweet?screen_name=delivid"
									className="button is-medium btn-blue"
								>
									<FontAwesomeIcon icon={['fab', 'twitter']} className="icon is-medium" />
									<span> Tweet Kami</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Tab4;
